module.exports = __webpack_public_path__ + "static/img/pic18.9caff63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic18.png
// module id = g8Dm
// module chunks = 0